export const getCurrentUserFromStorage = () => {
  try {
    const user = window.localStorage.getItem("currentUser");
    return user ? JSON.parse(user) : null;
  } catch (error) {
    console.error("Failed to get currentUser from localStorage:", error);
    return null;
  }
};

export const setCurrentUserToStorage = (user) => {
  if (!user) return;

  try {
    window.localStorage.setItem("currentUser", JSON.stringify(user));
  } catch (error) {
    console.error("Failed to save currentUser to localStorage:", error);
  }
};

export const removeCurrentUserFromStorage = () => {
  try {
    window.localStorage.removeItem("currentUser");
  } catch (error) {
    console.error("Failed to remove currentUser from localStorage:", error);
  }
};
